import React, { FC } from 'react';
import { Seo, useSeoDefaults } from '@funtech-int/yango-shared';
import { Person } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useI18n } from '@/shared/i18n/seo/useI18n';

import { personRoute } from '../../routes';

interface PersonHeadProps {
    person: Person;
}

export const PersonHead: FC<PersonHeadProps> = ({ person }) => {
    const intl = useI18n();
    const { seoSiteName } = useSeoDefaults();

    const personId = person.id.toString();
    const personName = person.name;

    const title = personName
        ? intl('person_seo_title', { name: personName, brandName: seoSiteName })
        : seoSiteName;

    const description = personName
        ? intl('person_meta_description', { name: personName, brandName: seoSiteName })
        : '-';

    const location = personRoute({ id: personId });

    return (
        <>
            <Seo.BasicMeta seoTitle={title} seoDescription={description} location={location} />
            <Seo.OgWebsiteMeta ogTitle={title} ogDescription={description} location={location} />
            <Seo.TwitterMeta twitterDescription={description} />
        </>
    );
};
